import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Formatter from "../../Data/Domain/Formatter";
import { message } from "antd";
import InterfaceTable from "../../Table/InterfaceTable";
import { getPropertiesByProject } from "../Application/Properties.business";
import {
  getPropertiesByProjectSelector,
  getPropertiesByProjectCountSelector,
} from "../Infrastructure/Properties.reducer";
import { ProjectOutlinedIcon } from "../../Utils/UI/Text";
import Modal from "../../Modal/Modal";
import { useNavigate } from "react-router-dom";

const PropertiesModal = ({ projectId, visible, onCancel }) => {
  const propertiesByProject = useSelector(getPropertiesByProjectSelector);
  const propertiesByCount = useSelector(getPropertiesByProjectCountSelector);
  const [values, setValues] = useState({
    page: 0,
    limit: 5,
  });
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState("false");

  const navigate = useNavigate();

  const goToProject = (projectId) => {
    navigate(`/projects/${projectId}`, { replace: true });
  };

  const columns = [
    {
      title: "Nombre",
      dataIndex: "project_name",
      key: "project_name",
    },
    {
      title: "Acciones",
      key: "",
      render: (_, record) => {
        return (
          <div style={{ display: "flex", gap: "8px" }}>
            <ProjectOutlinedIcon
              onClick={() => goToProject(record._id)}
              TooltipProjectOutlined="Detalle del Proyecto"
            />
          </div>
        );
      },
    },
  ];

  const fetchData = async (params = {}) => {
    try {
      setLoading(true);
      await getPropertiesByProject(projectId, params);
      const filtros = params.filter ? JSON.stringify(params.filter) : [""];
      setFilters(filtros);
      if (Object.entries(params).length > 0) message.success("Filtrado");
      setLoading(false);
    } catch (error) {
      message.error("Error al cargar los predios");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (projectId && visible) {
      fetchData({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, visible]);

  const handleRequest = (newPagination = {}, filters = {}, sorter = {}) => {
    const { current: page = 1, pageSize: limit = 5 } = newPagination;
    const { field: sortField, order: sortOrder } = sorter;
    const clean = Formatter.cleanParamsFromTableToAPI({
      ...filters,
      limit,
      sortField,
      sortOrder,
      page: page - 1,
      dates: [],
    });
    setValues({
      ...values,
      limit,
      page: page - 1,
    });
    fetchData(clean);
  };

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      title="Predios del Proyecto"
      width={800}
      footer={null}
    >
      <InterfaceTable
        rowKey="id"
        data={propertiesByProject}
        columns={columns}
        onChange={handleRequest}
        loading={loading}
        pagination={{
          pageSize: values.limit,
          total: propertiesByCount,
          onChange: (current) => {
            // Handle pagination change
          },
        }}
      />
    </Modal>
  );
};

export default PropertiesModal;
